import { render, staticRenderFns } from "./ItsCustomsApply.vue?vue&type=template&id=bcbdaafe&scoped=true&"
import script from "./ItsCustomsApply.vue?vue&type=script&lang=js&"
export * from "./ItsCustomsApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbdaafe",
  null
  
)

export default component.exports